class TestimonialComponent extends SlideshowComponent {
    constructor() {
      super();
      this.lastTestimonial_temp = null;
      this.firstTestimonial_temp = null;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.testimonial__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      let sliderItemsLength = this.sliderItemsToShow.length;
  
      if(this.sliderItemsToShow.length > 2 && window.matchMedia('(min-width: 760px)'))
      sliderItemsLength = this.sliderItems.length - 2;
      
      const isLastSlide = this.currentPage === sliderItemsLength;
      
      if (!isFirstSlide && !isLastSlide) return;
      
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
    //  if(this.currentPage == 'Infinity') return;
   
      this.sliderControlButtons.forEach(link => {link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
      });
  
     // this.removeExtraTestimonialSmaller();
  
      if(window.matchMedia('(min-width: 760px)'))
      {
        let current_slider = this.slider.querySelectorAll('.testimonial__slide');
        for (let element of current_slider) {element.classList.remove('slider--active')}
        current_slider[this.currentPage].classList.add('slider--active');
      }
  
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    /*[START] This function make sure when change screen size, the extra 2 tetimonials are deleted on small screens */
    /*removeExtraTestimonialSmaller(){
      let width = window.innerWidth;
      if(width < 760)
      {
          let ex_first_testimonial = document.querySelector('.extra_testimonial_1');
          let ex_last_testimonial = document.querySelector('.extra_testimonial_2');
          if(ex_first_testimonial)
          {
            this.firstTestimonial_temp = ex_first_testimonial;
            ex_first_testimonial.remove();
          }
          if(ex_last_testimonial)
          {
            this.lastTestimonial_temp = ex_last_testimonial;
            ex_last_testimonial.remove();
          }
      }
      else if(width >= 760 && this.firstTestimonial_temp != null && this.lastTestimonial_temp != null){
          let slides_container = document.querySelector('.testimonials .grid');
          if(slides_container)
          {
            slides_container.append(this.lastTestimonial_temp);
            slides_container.prepend(this.firstTestimonial_temp);
          }
          this.lastTestimonial_temp = null;
          this.firstTestimonial_temp = null;
      }
    }*/
    /*[END] This function make sure when change screen size, the extra 2 tetimonials are deleted on small screens */
  
    autoRotateSlides() {
      let sliderItemsLength = this.sliderItems.length;
      if(this.sliderItems.length > 2 && window.matchMedia('(min-width: 760px)'))
      sliderItemsLength = this.sliderItems.length - 2;
  
      const slideScrollPosition = this.currentPage === sliderItemsLength ? 0 : this.slider.scrollLeft + this.slider.querySelector('.testimonial__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('testimonial-component', TestimonialComponent);
  